module.exports = __webpack_public_path__ + "static/img/ic_middle_on@2x.4199187.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_middle_on@2x.png
// module id = 8KjK
// module chunks = 1